export default __webpack_public_path__ + "static/media/dashboard-contacts.8bd351f3.svg";